<template>
	<div ref="pageSelectModal" class="dialog-container">
		<div class="dialog" style="max-height: 247px; max-width: 746px;transform: translate(0, -120px);">
			<form @submit.stop="doValidation()">
				<div class="top">
					<p class="txt-crud-title">
						Page Select
					</p>
				</div>
				<div class="center">
					<table class="tb-crud-horizon">
						<colgroup>
							<col width="22%" />
							<col width="78%" />
						</colgroup>
						<tbody>
							<tr>
								<th>Page Name</th>
								<td>
									<select ref="pageSelect" class="select-crud" required v-model="item.pageName" name="pageName" @change="doDuplicateCheck()">
										<option value="">-- Select --</option>
										<option v-for="page in pageList" :key="page.pageNo" :value="page.pageNo">{{ page.pageName }}</option>
									</select>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="bottom">
					<button type="button" class="btn-save fright" title="Save" @click.stop="doPageView()">
						Save
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" style="margin-right: 10px;" @click="doCancel()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";

export default {
    name: "PageSelectModal",
    created () {
		this.logger.debug(this, "created()");
		this.items.ocrFieldType = this.$attrs.param;
		this.selectPageList();
    },
    data() {
        return {
			items: {},
			pageList: [],
			item: { pageName: "" },
			selectedPageNo: [],
			isDuplicate: false,
		};
    },
	
	props: {
	},
    methods: {
		selectPageList() {
			this.logger.debug(this, "selectPageList()");
			axios
				.post(this.config.contextRoot + "/page/selectList.do", {projectNo: this.$route.params.projectNo, searchCategory: "ALL"})
				.then((response) => {
					console.log(response);
					this.pageList = response.data.pageList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
        doValidation() {
			this.logger.debug(this, "doValidation()");

			if(this.isDuplicate == true)
			{
				return false;
			}
        },
        doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the Save OCR Template Create?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.pageSelectModal.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.pageSelectModal.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isOcrPageSelect");
			}.bind(this), 410);
		},
		doDuplicateCheck() {
			this.logger.debug(this, "doDuplicateCheck()");
			axios
				.post(this.config.contextRoot + "/visit/duplicateCheck.do", this.item)
				.then((response) => {
					console.log(response);
					if(response.data.visitExistCount == 0)
					{
						this.isDuplicate = false;
					}
					else
					{
						this.isDuplicate = true;
					}
				});
		},
		doPageView() {
			this.logger.debug(this, "doPageView()");
			const pageNo = this.$refs.pageSelect.value;
			const pageName = this.$refs.pageSelect.options[this.$refs.pageSelect.selectedIndex].text;
			let pageInfo = {
				pageNo: pageNo,
				pageName: pageName,
			}
			if (pageNo === "") {
				this.$confirm("Please select a page.", "Warning", "warning").then(() => {
					this.$refs.pageSelect.focus();
				});
				return;
			}
			EventBus.$emit("ocr-page-view", pageInfo);
			this.doClose();
		},
    },
}
</script>

<style scoped>
.dialog-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 9999;
	animation: fadein .4s ease-in-out both;
}
.btn-cancel {
	margin-right: 0px;
}
</style>